import { Phone, UserPlus } from "lucide-react";
import { PHONE_HREF } from "./data";
import { scrollToId } from "./motion";

export const MobileCallBar = () => (
  <div data-testid="mobile-call-bar" className="fixed inset-x-3 bottom-3 z-40 flex gap-2 rounded-full border border-white/10 bg-[#0A0A0A]/90 p-1.5 backdrop-blur-xl sm:hidden">
    <a href={PHONE_HREF} data-testid="mobile-call-bar-call" className="flex flex-1 items-center justify-center gap-2 rounded-full bg-brand-400 py-3 font-display text-sm font-bold text-[#0A0A0A]">
      <Phone className="h-4 w-4" strokeWidth={2.5} /> Call now
    </a>
    <button onClick={() => scrollToId("partners")} data-testid="mobile-call-bar-apply" className="flex flex-1 items-center justify-center gap-2 rounded-full border border-white/15 py-3 font-display text-sm font-semibold text-white">
      <UserPlus className="h-4 w-4" /> Apply
    </button>
  </div>
);
